<template>
  <pt-goods-qr-code class="pt-goods-qr-code__page"></pt-goods-qr-code>
</template>

<script>
import PtGoodsQrCode from 'cps/mall-manage/pt-goods-qr-code/withData'
export default {
  name: 'pt-goods-qr-code__view',
  components: {
    'pt-goods-qr-code': PtGoodsQrCode
  }
}
</script>
